import { Component } from '@angular/core';
import { FormBuilder, FormControl, Validators, FormArray, FormGroup } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { MessagesService } from 'src/app/shared/services/messages.service';
import { MessagingService } from 'src/app/shared/services/messaging.service';
import { ControlsOf, TranslateWithFallbackPipe } from 'acl-cloud-lib';
import { Message, MessageTypeEnum, Relation, RelationSubjectTypeEnum } from 'src/api/generated';

@Component({
  selector: 'app-messaging',
  templateUrl: './messaging.component.html',
  styleUrl: './messaging.component.scss'
})
export class MessagingComponent {
  private _parentMessages: BehaviorSubject<Message[]> = new BehaviorSubject<Message[]>([]);
  public parentMessages$: Observable<Message[]> = this._parentMessages.asObservable();
  private _childMessages: BehaviorSubject<Message[]> = new BehaviorSubject<Message[]>([]);
  public childMessages$: Observable<Message[]> = this._childMessages.asObservable();
  public message?: Message;
  public count: number = 0;
  public isNewMessage: boolean = false;

  //declares a FormGroup
  public frmData: FormGroup;

  constructor(
    private _msgSvc: MessagingService,
    private _msgsSvc: MessagesService,
    fb: FormBuilder,
    private readonly _translate: TranslateWithFallbackPipe
  ) {
    //We define the FormGroup
    this.frmData = fb.group<ControlsOf<Message>>({
      Id: new FormControl('', {nonNullable: true}),
      Name: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
      Version: new FormControl(0, {nonNullable: true}),
      Tags: new FormControl([], {nonNullable: true}),
      Created: new FormControl(new Date(), {nonNullable: true}),
      Modified: new FormControl(new Date(), {nonNullable: true}),
      SourceId: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
      MessageType: new FormControl(MessageTypeEnum.None, {nonNullable: true}),
      MessageContent: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
      ParentId: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
      Attachments: new FormControl([], {nonNullable: true}),
      Destinators: new FormArray([fb.group<ControlsOf<Relation>>({
        SubjectId: new FormControl('', {nonNullable: true}),
        Description: new FormControl('', {nonNullable: true}),
        SubjectType: new FormControl(RelationSubjectTypeEnum.None, {nonNullable: true}),
      })]),
      MessageSource: fb.group<ControlsOf<Relation>>({
        SubjectId: new FormControl('', {nonNullable: true}),
        Description: new FormControl('', {nonNullable: true}),
        SubjectType: new FormControl(RelationSubjectTypeEnum.None, {nonNullable: true}),
      }),
      Status: new FormControl('', {nonNullable: true}),
    });
  }

  ngOnInit(): void { }

  public get MsgSvc(): MessagingService {
    return this._msgSvc;
  }

  public save(): void {
    try {
      this.frmData.controls["ParentId"].patchValue("000000000000000000000000");
      if (this.frmData.valid) {
        this._msgSvc.SaveMessage(this.frmData.value);
        this.frmData.markAsPristine();
      }
      else {
        this._msgsSvc.ShowError(this._translate.transform('invalid-data'));
      }
    } finally {
      this.isNewMessage = false;
    }
  }
}
